import React, { cloneElement } from 'react';
import { Transition } from 'react-transition-group';
const getStyles = (duration) => ({
    transition: `transform ${duration}ms ease-in-out`,
});
const GrowStyles = {
    entering: {
        transform: 'scale(1, 1)',
    },
    entered: {
        transform: 'scale(1, 1)',
    },
    exiting: {
        transform: 'scale(0, 0)',
    },
    exited: {
        transform: 'scale(0, 0)',
    },
};
const Grow = (props) => {
    const defaultStyles = getStyles(props.duration);
    return (React.createElement(Transition, { in: props.show, timeout: props.duration, mountOnEnter: true, unmountOnExit: true }, (state) => cloneElement(props.children, { style: Object.assign(Object.assign(Object.assign({}, props.style), defaultStyles), GrowStyles[state]) })));
};
export default Grow;
